import React, { useEffect, useState } from 'react'
import { clearSignup, postSignup, updateSignup } from '../../redux/ducks/signup';
import { connect } from 'react-redux'
import { Formik,Form, Field } from 'formik';
import { Checkbox, Switch, TextField } from 'formik-material-ui';

import { makeStyles, Container, Grid, LinearProgress, Typography, Button, FormLabel, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import {FormikPersistStore} from '../../component/FormikPersistStore'
import FormikRadioGroup from '../../component/FormikRadioGroup'
import {checkRequiredHandler} from '../../component/FormUtil'
import { Link } from 'react-router-dom';
import { history, MyMess } from '../../App';
import { GlobalSnackBarUtil } from '../../component/GlobalSnackBar';
import {isAlphanumeric, isEmail} from '../../utils/Utils';
import { useSelector } from 'react-redux';

import signupImage from '../../images/Signup.png'
import logoImage from '../../images/logo.png'

import signup1 from '../../images/signup/slider01.png'
import signup2 from '../../images/signup/slider02.png'
import signup3 from '../../images/signup/slider03.png'
import signup4 from '../../images/signup/slider04.png'

import signup1tc from '../../images/signup/slider01_tc.png'
import signup2tc from '../../images/signup/slider02_tc.png'
import signup3tc from '../../images/signup/slider03_tc.png'
import signup4tc from '../../images/signup/slider04_tc.png'

import signup1sc from '../../images/signup/slider01_sc.png'
import signup2sc from '../../images/signup/slider02_sc.png'
import signup3sc from '../../images/signup/slider03_sc.png'
import signup4sc from '../../images/signup/slider04_sc.png'


import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import {GreenButton} from '../../component/colorButton';
import LangChangeSelect from '../../component/LangChangeSelect';
import Footer from '../../component/footer';
import Hidden from '@material-ui/core/Hidden';
import Axios from 'axios';
import Carousel from 'react-material-ui-carousel';

import {CheckUrl} from '../../server/WebServiceUrl'
import { globalPathParams } from '../Main';

const enItems = [signup1, signup2, signup3, signup4];
const tcItems = [signup1tc, signup2tc, signup3tc, signup4tc];
const scItems = [signup1sc, signup2sc, signup3sc, signup4sc];

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        height: '100vh'
    },
      paper: {
        position:'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flex: 1
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(3),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
    landingImage: {
        flex: 1,
        position: 'relative'
    },
    landingImage2: {
        maxWidth: '100%'
    },
    logo: {
    width: '60%'
    },
    cardRoot: {
    minWidth: 345,
    maxWidth: 345,
    },
    langPicker: {
    position: 'absolute',
    top: 15,
    right: 15
    },
    floatRight: {
    float: 'right'
    },
    link: {
    color: "#5db4a2",
    '&:visited' :{
        color: "#5db4a2",
    }
    },
    kppUrl:{
        color: 'green',
        overflowWrap: 'break-word'
    },
    urlError:{
        color:'red'
    }
}));

// const checkRequiredHandler = (fields,values,errors) => {
//     fields.forEach(field =>{
//         if(!values[field]){
//             errors[field] = 'Required';
//         }
//     })


//     return errors;
// }

function SignUpForm(props) {
    let app = useSelector(state => state.app);
    MyMess.setLanguage(app.lang);
    let [formState,setFormState] = useState({
        kppUrl:'https://myshop.my.kopapro.com',
        urlError:''
    })

    let items = enItems;
    if (app.lang === 'zhTW') {
        items = tcItems;
    } else if (app.lang === 'zhCN') {
        items = scItems;
    } 

    const classes = useStyles();
    const validateHandler = values => {
        const errors = {};
        // checkRequiredHandler(['email','password','repw'],values,errors);
        if(values.password !== values.repw){
            errors.repw =  MyMess.signUp.notMatchPassword
        }      

        if (values.email && !isEmail(values.email)) {
            errors.email = MyMess.general.errors.email
        }

        if(values.email && values.email.length > 100){
            errors.email = MyMess.formatString(MyMess.general.errors.maxLength, 100)
        }

        if(values.password && values.password.length > 40){
            errors.password = MyMess.formatString(MyMess.general.errors.maxLength, 40)
        }

        if(values.code && values.code.length > 20){
            errors.code = MyMess.formatString(MyMess.general.errors.maxLength, 20) 
        }

        if(values.desc && values.desc.length > 200){
            errors.desc = MyMess.formatString(MyMess.general.errors.maxLength, 200)
        }

        if(values.code && !isAlphanumeric(values.code)){
            errors.code = MyMess.KppResponse.ILLEGAL_ALPHANUMERIC
        }

        return errors;
    }

    const submitHandler =(values, { setSubmitting }) => {

        signupFormData.email = signupFormData.email.toLowerCase();
        if(signupFormData.refCode)
            signupFormData.refCode = signupFormData.refCode.toUpperCase();
        //console.log('on submmit?');
        if(formState.urlError){
            setSubmitting(false);
            return;
        }

        let signUpCallback = (responseData) => {
            setSubmitting(false);           
            if(!responseData.pass){
                // GlobalSnackBarUtil.open({
                //     message:MyMess.getString(responseData.error),
                //     severity:'error'
                //   })

               if(responseData.locator){
                   //console.log(responseData.locator);
                   let formErrors = {

                   }

                   responseData.locator.forEach((v,i) => {
                       formErrors[v.field] = MyMess.KppResponse[v.mess];                       
                   });                   
                   formAPI.setErrors(formErrors);
               }   
            }else{
                props.clearSignup();
                if(formAPI.resetForm){
                    formAPI.resetForm();
                }
                GlobalSnackBarUtil.open({
                    message: MyMess.signUp.successInfo,
                    severity:'success'
                })                
               history.push('/sendVerify/' + signupFormData.email);
            }
            

        }
        // console.log('data before post');
        // console.log(signupFormData.needTrial);
        // console.log(signupFormData.trial);
        props.postSignUp(signupFormData, signUpCallback);        
      }
    
    
    const formAPI = {};

    const signupFormData = {
        ...props.signup,
        repw: '',
        needTrial: 'true'
    }  

    if(globalPathParams.refCode){
        signupFormData.refCode = globalPathParams.refCode;
    }

    const updateStoreHandler = (data) => {
        props.updateSignUp(data);
    }

    useEffect(() => {
        console.log('store sign up data changed') 
        

        return () => {
            props.clearSignup();      
        }
    }, [])

    useEffect(()=>{
        
        const doCheckUrl = async () => {
            if(signupFormData.code){
            //check alphanumeric
                let re = /^[a-z0-9]+$/i;                       
                let myFormState = {
                    ...formState
                }
                if(!re.test(signupFormData.code)){                   
                    myFormState.urlError = MyMess.general.errors.alphanumericOnly;                    
                }else{                                  
                    myFormState.urlError = '';
                }
       

                if(!myFormState.urlError){
                    try{
                        let result = await Axios.get(CheckUrl,{params:{url:signupFormData.code}});                    
                        if(result.data && result.data.pass && result.data.info){
                            
                            myFormState.kppUrl = result.data.info.url
                            
                        }

                    }catch(e){

                    }
                }

                setFormState(myFormState);
            }
        }
        signupFormData.code = signupFormData.code.toLowerCase();
        
        
        doCheckUrl();

    },[signupFormData.code])


    const formComponent = () => {

        return (
            <Form className={classes.form}>
                <Grid container spacing={2}>
                
                    <Grid item xs={12}>                
                        <Field                                
                        name="email"
                        type="email"                                
                        render={(props) => 
                            <TextField 
                            variant="outlined"
                            inputProps={{ style: { textTransform: "lowercase" } }}
                            required
                            label={MyMess.general.emailAddress}
                            fullWidth {...props}/>}                                       
                            
                        ></Field>
                        
                    </Grid>
                    <Grid item xs={12}>                
                        <Field
                        
                        name="password"
                        type="password"
                        render={(props) => 
                            <TextField 
                            variant="outlined"
                            required
                            label={MyMess.signUp.password}
                            type="password"
                            fullWidth {...props}/>}          
                        />                
                    </Grid>
                    <Grid item xs={12}>                
                        <Field                                
                        name="repw"
                        type="password"
                        render={(props) => 
                            <TextField 
                            variant="outlined"
                            type="password"
                            required
                            label={MyMess.signUp.confirmPw}
                            fullWidth {...props}/>}    
                        />                
                    </Grid>
                    <Grid>
                        {/* {<FormLabel component="legend">{MyMess.needTrial}</FormLabel>
                        <RadioGroup aria-label={MyMess.needTrial} name="needTrial" onChange={handleTrialChange}>
                            <FormControlLabel value="true" control={<Radio />} label={MyMess.general.yes} />
                            <FormControlLabel value="false" control={<Radio />} label={MyMess.general.no} />                            
                        </RadioGroup>} */}
                        <FormControlLabel
                        control={
                            <Field component={Switch}  type="checkbox" name="trial"                              
                            />
                        }
                        label={MyMess.needTrial}
                        />                       
                    </Grid> 
                    { signupFormData.trial && trialKppComponents()                                       
                    }
                    <GreenButton
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        {MyMess.general.signUp}
                    </GreenButton>
                    <Grid container justify="center">
                        <Grid item >
                            <Link to="/login" variant="body2" className={classes.link}>
                            {MyMess.general.returnToLogin}
                            </Link>
                        </Grid>
                    </Grid>
                </Grid>
                <FormikPersistStore name="singUpForm" handler={updateStoreHandler}></FormikPersistStore>
            </Form>            
        )
    }

    const trialKppComponents = () => {
        
        let planOptions = () => {
            let options = [
                { value:"su" ,label: MyMess.kopaproLicense.plan.su}        
                ,{value:"bu" ,label:MyMess.kopaproLicense.plan.bu}
                ,{value:"pm" ,label:MyMess.kopaproLicense.plan.pm }
                ]
        
            return options;
        }

        return (
            <React.Fragment>
                <Grid item xs={12}>                
                    <Field                                
                    name="code"                                           
                    render={(props) => 
                        <TextField 
                        variant="outlined"
                        required
                        inputProps={{ style: { textTransform: "lowercase" } }}
                        label={MyMess.kopaproLicense.code}                        
                        fullWidth {...props}/>}                                      
                        
                    ></Field>
                    <Typography variant="caption" >
                        {MyMess.kopaproLicense.codeHelperText}
                    </Typography>  
                    {formState.kppUrl && <br></br>}
                    <Typography variant="caption" className={classes.kppUrl}>
                        {formState.kppUrl}
                    </Typography>                     
                    {formState.urlError && <br></br>}
                    <Typography variant="caption" className={classes.urlError}>
                        {formState.urlError}
                    </Typography> 
                    
                </Grid>                
                <Grid item xs={12}>                
                    <Field                                
                    name="desc"                                           
                    render={(props) => 
                        <TextField 
                        variant="outlined"
                        required
                        label={MyMess.kopaproLicense.desc}
                        fullWidth {...props}/>}                                      
                        
                    ></Field>
                </Grid>
                {/* <Grid item xs={12}>                
                    <Field                                
                    name="refCode"                                           
                    render={(props) => 
                        <TextField 
                        variant="outlined"
                        label={MyMess.kopaproLicense.refCode}
                        fullWidth {...props}/>}                                      
                        
                    ></Field>
                </Grid> */}
                <Grid item xs={12}>                               
                <FormLabel component="legend">{MyMess.kopaproLicense.plan.plan}</FormLabel>                                             
                    <Field
                        name="plan"
                        component={FormikRadioGroup}
                        row
                        options={planOptions()}
                    />                
                </Grid>  
            </React.Fragment>
        )   
    }


    return (
        
        <div>
            <div className="s">
                <div className="a"></div>
                <div className="b"></div>
                <div className="c"></div>
                <div className="d"></div>
            </div>
            <div className={classes.langPicker}>
                <LangChangeSelect variant="" />
            </div>
            <Formik
                initialValues={signupFormData}        
                validate={validateHandler}
                onSubmit={submitHandler}      
                //enableReinitialize={true}  
                >
                {({ submitForm, isSubmitting , resetForm,setErrors }) => (                
                    <Container component="main" className={classes.root} maxWidth="xl">
                        { 
                            formAPI.resetForm = resetForm                                                   
                        }
                        {
                            formAPI.setErrors = setErrors
                        }
                        {isSubmitting  && <LinearProgress />}
                        <div className={classes.paper}>
                            <Card className={classes.cardRoot} raised={true}>
                                <CardHeader
                                title={<img src={logoImage} className={classes.logo}/>}
                                />
                                <CardContent>
                                <Typography component="h5" variant="h5">
                                    {MyMess.signUp.title}
                                </Typography>
                                {formComponent()}
                                </CardContent>
                            </Card>
                        </div>
                        <Hidden only={['xs', 'sm']}>
                        <Carousel className={classes.landingImage}>
                            {
                                items.map( (item, i) => {
                                    return (
                                        <div >
                                            <img className={classes.landingImage2} src={item}  />
                                        </div>
                                    )
                                })
                            }
                        </Carousel>
                        </Hidden>
                    </Container>
                )}
            </Formik>
            <Footer />
        </div>
        
    )
}
const mapStateToProps = state => ({
    signup: state.signup
  })
  
  const mapDispatchToProps = dispatch => ({
    postSignUp: (signUpFormData, setSubmitting) => { dispatch(postSignup(signUpFormData,setSubmitting)); },
    updateSignUp: (data) => {dispatch(updateSignup(data))} ,
    clearSignup: () => {dispatch(clearSignup())} 
  });
  export default connect(mapStateToProps,mapDispatchToProps)(SignUpForm);
